import { CustomContentProps } from 'notistack'
import React from 'react'
import { Flex } from '../core/Flex'
import { SuccessIcon } from '../core/icons'
import Text from '../core/Text/Text'
import { SnackContainer } from './InfoSnack'

export const ModalSuccessSnack = React.forwardRef<HTMLDivElement, CustomContentProps>(
  (props: CustomContentProps, ref) => {
    const { message } = props

    return (
      <SnackContainer
        css={{
          backgroundColor: '#43a047'
        }}
        ref={ref}
      >
        <Flex css={{ padding: '8px 0px', alignItems: 'center' }}>
          <SuccessIcon
            width={'1em'}
            height={'1em'}
            fill={'#FFFFFF'}
            style={{
              fontSize: '20px',
              marginInlineEnd: '8px',
              userSelect: 'none',
              display: 'inline-block',
              flexShrink: 0
            }}
          />
          <Text type={'primary_inverted'} size={'14'}>
            {message}
          </Text>
        </Flex>
      </SnackContainer>
    )
  }
)
